/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Shopping_Running_Low_ToggleInputs */

const en_shopping_running_low_toggle = /** @type {(inputs: Shopping_Running_Low_ToggleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Restock ${i?.name}`)
};

const de_shopping_running_low_toggle = /** @type {(inputs: Shopping_Running_Low_ToggleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} nachkaufen`)
};

/**
* | output |
* | --- |
* | "Restock {name}" |
*
* @param {Shopping_Running_Low_ToggleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_running_low_toggle = /** @type {((inputs: Shopping_Running_Low_ToggleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_Running_Low_ToggleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_running_low_toggle(inputs)
	return en_shopping_running_low_toggle(inputs)
});